import { axiosInstance as axios } from "services";

export const fetchAllSeriesCarting = async (params) => {
  const { data } = await axios.get("/pricing/master/carting", { params });
  if (!data.success) throw new Error(data.error?.message || "Failed to fetch carting data");
  return data;
};

